// Studentcode staat in studentProfile.studentCode; sommige API's sturen het plat mee als studentCode.
export const getStudentCode = (student) => String(
  student?.studentProfile?.studentCode || student?.studentCode || ''
).trim();

// Zoektekst voor een student, inclusief studentcode, voor alle zoek-/filtervelden.
export const studentSearchText = (student, ...extra) => [
  student?.name,
  student?.firstName,
  student?.lastName,
  student?.email,
  getStudentCode(student),
  ...extra
].filter(Boolean).join(' ').toLowerCase();
